import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { App, Button, Popconfirm } from 'antd';
import { useTranslation } from 'translations/hooks';

import { SegmentHistory } from 'business/quality-control/pages/segment-history/hooks/data/types';
import { useSegmentHistoryV1ControllerDeleteSegmentHistory } from 'generated/apiComponents';
import { Quality_SegmentHistoryStatusEnum_Enum } from 'generated/graphql';

import { ScanStatusDeletable } from './add-manuel-scan-modal/types';

export const ActionsExpandedColumn = ({
  record,
  refetchData,
  isUserManager = false,
}: {
  record: SegmentHistory;
  refetchData: () => void;
  isUserManager?: boolean;
}) => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  const { mutate: deleteSegmentHistory } =
    useSegmentHistoryV1ControllerDeleteSegmentHistory();

  if (
    !isUserManager ||
    !record.status ||
    !ScanStatusDeletable.includes(
      record.status as Quality_SegmentHistoryStatusEnum_Enum,
    )
  ) {
    return null;
  }

  const deleteRecord = async () => {
    deleteSegmentHistory(
      {
        body: {
          id: record.id,
        },
      },
      {
        onSuccess: async () => {
          refetchData();
          message.open({
            type: 'success',
            content: t(
              'qualityControl.segmentHistory.expandedColumns.delete.success',
            ),
          });
        },
        onError: () => {
          message.open({
            type: 'error',
            content: t(
              'qualityControl.segmentHistory.expandedColumns.delete.error',
            ),
          });
        },
      },
    );
  };

  return (
    <Popconfirm
      title={t('qualityControl.segmentHistory.expandedColumns.delete.title')}
      description={t(
        'qualityControl.segmentHistory.expandedColumns.delete.description',
      )}
      onConfirm={() => deleteRecord()}
      okText={t('common.booleanValue.state_true')}
      cancelText={t('common.booleanValue.state_false')}
      okButtonProps={{ danger: true }}
      icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
    >
      <Button type="text" danger icon={<DeleteOutlined />} />
    </Popconfirm>
  );
};
